import LayoutPage from "../../Components/LayoutPage"
import NavLayer2 from "../../Components/NavLayer2/NavLayer2"
import Container from "./Components/Container"

const RulesInvite = [
  {question: "همکاری در فروش",
    answer: (
      <div>
        <p>در سیستم همکاری در فروش (Referral) کمیسیون پایه ۵٪ است که در صورت عبور از ۱۰ معرفی موفق، به ۸٪ و ۲۵ فروش به ۱۰٪ افزایش می‌یابد. (به عنوان مثال با خرید یک اکانت ۸۴ دلاری توسط زیرموجموعه شما ۴.۲ دلار به کیف پول شما منتقل خواهد شد. این رقم در صورت رسیدن به ۱۰ زیرمجموعه، به ۶.۷۲ دلار افزایش می‌یابد.)</p>
        <p>همچنین تسویه حساب‌ها با رسیدن به حداقل مبلغ قابل برداشت پلتفرم (۵۰ دلار)، انجام می‌پذیرد.</p>
      </div>
    ),
  },
]

export default function NotificationAll() {
  return (
    <LayoutPage activeIndex={15} navItems={["قوانین"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5">
      <NavLayer2 texts={["عمومی" , "چالش‌ها", "برداشت", "دعوت از دوستان"]} hrefs={["/rule/general" , "/rule/challenge", "/rule/withdraw", "/rule/invite"]} activeIndex={3} className="!gap-2 sm:!gap-5"/>
      <div className="w-full h-fit flex flex-col items-center gap-5 min-h-0 overflow-y-auto">
        <Container items={RulesInvite}/>
      </div>
    </LayoutPage>
  )
}